import React, { useState } from 'react';
import useServerApi from '../../../hooks/useServerApi';

function CancelConfirmDialog({ onConfirm, onCancel, subscriptionId }) {
    const [{ post }] = useServerApi();
    const [errors, setErrors] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [reason, setReason] = useState("");
    const [otherText, setOtherText] = useState("");
    // ...existing code...

    const reasons = [
        "Too confusing",
        "Too expensive",
        "Lacked features that I need",
        "Other"
    ];

    const validate = () => {
        if (!reason) return "Please select a reason.";
        if (reason === "Other" && !otherText.trim()) return "Please specify your reason.";
        return "";
    };

    const onCancelConfirm = async () => {
        const err = validate();
        if (err) {
            setErrors(err);
            return;
        }
        setErrors("");
        setIsLoading(true);
        try {
            const payload = {
                subscription_id: subscriptionId,
                cancel_reason: reason,
                comments: reason === "Other" ? otherText : ""
            };
            const [success, response] = await post('/rest_endpoints/stripe/crud/cancel', payload);
            if (success && response?.message) {
                onConfirm();
            } else {
                setErrors(response?.message || "Failed to cancel subscription.");
            }
        } catch (error) {
            setErrors("An unexpected error occurred.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 z-50">
            <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-md">
                <h2 className="text-2xl font-semibold mb-2">Cancel Subscription</h2>
                <p className="mb-6 text-gray-500">We're sorry to see you go. Please let us know why you're canceling.</p>
                <div className="mb-4">
                    <label className="font-medium text-lg mb-2 block">Why are you canceling?</label>
                    <div className="flex flex-col gap-3">
                        {reasons.map((r) => (
                            <label key={r} className="flex items-center border rounded px-4 py-3 cursor-pointer bg-white hover:bg-gray-50">
                                <input
                                    type="radio"
                                    name="cancel-reason"
                                    value={r}
                                    checked={reason === r}
                                    onChange={() => { setReason(r); }}
                                    className="mr-3 h-5 w-5 accent-blue-600"
                                />
                                <span className="text-base">{r}</span>
                            </label>
                        ))}
                    </div>
                    {reason === "Other" && (
                        <input
                            type="text"
                            className="mt-4 w-full border rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="Please specify your reason"
                            value={otherText}
                            onChange={e => { setOtherText(e.target.value); }}
                        />
                    )}
                </div>
                {errors && (
                    <div className="mb-4 text-red-600 text-sm">{errors}</div>
                )}
                {!subscriptionId && (
                    <div className="mb-4 text-red-600 text-sm">
                        Subscription ID is missing. Cannot proceed with cancellation.
                    </div>
                )}
                <div className="flex justify-between mt-6 gap-3">
                    <button
                        className="px-4 py-2 bg-gray-100 text-gray-800 rounded hover:bg-gray-200 font-medium w-1/2"
                        onClick={onCancel}
                        disabled={isLoading}
                    >
                        Keep Subscription
                    </button>
                    <button
                        className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 font-medium w-1/2"
                        onClick={onCancelConfirm}
                        disabled={isLoading || !subscriptionId}
                    >
                        {isLoading ? "Cancelling..." : "Continue Cancellation"}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default CancelConfirmDialog;
